import React, { useState, useEffect } from 'react';
import { FaSync, FaPlus, FaEdit, FaTrash, FaSearch, FaHandHoldingUsd } from 'react-icons/fa';
import axiosInstance from '../utils/axiosInstance';
import { toast } from 'react-toastify';
import dayjs from 'dayjs';

const AY_ADLARI = ['', 'Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran',
  'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'];
const KASALAR = ['FAYNPAY', 'NEOPAYS', 'ULTRAPAY', 'FULGUR', 'ANINDA', 'MİNİ', 'ENHİZLİ', 'DIS_KASA'];
const fmt = (n) => new Intl.NumberFormat('tr-TR', { minimumFractionDigits: 2 }).format(n ?? 0);
const BOSH = { tarih: dayjs().format('YYYY-MM-DD'), kasa: '', yontem: '', alici: '', miktar: 0, komisyon: 0, toplam: 0, not: '' };

const TahsilatYonetimi = () => {
  const bugun = dayjs();
  const [kayitlar, setKayitlar] = useState([]);
  const [ozet, setOzet]         = useState([]);
  const [loading, setLoading]   = useState(true);
  const [search, setSearch]     = useState('');
  const [filtre, setFiltre]     = useState({ kasa: '', ay: bugun.month() + 1, yil: bugun.year() });
  const [modal, setModal]       = useState(false);
  const [secili, setSecili]     = useState(null);
  const [form, setForm]         = useState(BOSH);

  const fetchData = async () => {
    setLoading(true);
    try {
      const p = new URLSearchParams(Object.fromEntries(Object.entries(filtre).filter(([, v]) => v)));
      const [listRes, ozetRes] = await Promise.all([
        axiosInstance.get(`/tahsilat/all?${p}`),
        axiosInstance.get(`/tahsilat/ozet?ay=${filtre.ay}&yil=${filtre.yil}`),
      ]);
      setKayitlar(listRes.data);
      setOzet(ozetRes.data);
    } catch { toast.error('Veriler yüklenemedi!'); }
    finally { setLoading(false); }
  };

  useEffect(() => { fetchData(); }, [filtre.kasa, filtre.ay, filtre.yil]);

  const handleEkle  = () => { setForm(BOSH); setSecili(null); setModal(true); };
  const handleDuzenle = (k) => {
    setSecili(k);
    setForm({ tarih: dayjs(k.tarih?.full).format('YYYY-MM-DD'), kasa: k.kasa, yontem: k.yontem, alici: k.alici ?? '', miktar: k.miktar, komisyon: k.komisyon, toplam: k.toplam, not: k.not ?? '' });
    setModal(true);
  };

  const handleKaydet = async () => {
    try {
      if (!secili) { await axiosInstance.post('/tahsilat/add', form); toast.success('Tahsilat eklendi.'); }
      else { await axiosInstance.patch(`/tahsilat/update/${secili._id}`, form); toast.success('Güncellendi.'); }
      setModal(false); fetchData();
    } catch { toast.error('İşlem başarısız!'); }
  };

  const handleSil = async (id) => {
    if (!window.confirm('Silinsin mi?')) return;
    try { await axiosInstance.delete(`/tahsilat/delete/${id}`); toast.success('Silindi.'); fetchData(); }
    catch { toast.error('Silme başarısız!'); }
  };

  // Özet kasa bazında
  const ozetMap = {};
  ozet.forEach(o => {
    const kasa = o._id?.kasa ?? '?';
    if (!ozetMap[kasa]) ozetMap[kasa] = { miktar: 0, komisyon: 0, net: 0, sayi: 0 };
    ozetMap[kasa].miktar    += o.toplamMiktar   ?? 0;
    ozetMap[kasa].komisyon  += o.toplamKomisyon ?? 0;
    ozetMap[kasa].net       += o.toplamNet      ?? 0;
    ozetMap[kasa].sayi      += o.islemSayisi    ?? 0;
  });

  const filtered = kayitlar.filter(k =>
    !search ||
    (k.kasa ?? '').toLowerCase().includes(search.toLowerCase()) ||
    (k.yontem ?? '').toLowerCase().includes(search.toLowerCase()) ||
    (k.alici ?? '').toLowerCase().includes(search.toLowerCase())
  );

  const toplamNet = Object.values(ozetMap).reduce((s, v) => s + v.net, 0);

  return (
    <div style={S.container}>
      {/* Header */}
      <div style={S.header}>
        <div>
          <h2 style={S.hTitle}>
            <FaHandHoldingUsd style={{ color: '#f27127', marginRight: 10 }} />
            Tahsilat Yönetimi
            <span style={S.badge}>{kayitlar.length}</span>
          </h2>
          <p style={S.hSub}>{AY_ADLARI[filtre.ay]} {filtre.yil} • Toplam Net: <strong style={{ color: '#2ecc71' }}>{fmt(toplamNet)} TL</strong></p>
        </div>
        <div style={S.hRow}>
          <select style={S.select} value={filtre.kasa} onChange={e => setFiltre(p => ({ ...p, kasa: e.target.value }))}>
            <option value="">Tüm Kasalar</option>
            {KASALAR.map(k => <option key={k} value={k}>{k}</option>)}
          </select>
          <select style={S.select} value={filtre.ay} onChange={e => setFiltre(p => ({ ...p, ay: Number(e.target.value) }))}>
            {AY_ADLARI.slice(1).map((ad, i) => <option key={i+1} value={i+1}>{ad}</option>)}
          </select>
          <select style={S.select} value={filtre.yil} onChange={e => setFiltre(p => ({ ...p, yil: Number(e.target.value) }))}>
            {[2024, 2025, 2026, 2027].map(y => <option key={y} value={y}>{y}</option>)}
          </select>
          <button style={S.iconBtn} onClick={fetchData}>
            <FaSync style={loading ? { animation: 'spin 1s linear infinite' } : {}} />
          </button>
          <button style={S.addBtn} onClick={handleEkle}><FaPlus /> Ekle</button>
        </div>
      </div>

      {/* Özet Kartlar */}
      <div style={S.ozetGrid}>
        {Object.entries(ozetMap).map(([kasa, t]) => (
          <div key={kasa} style={S.ozetCard}>
            <p style={S.ozetKasa}>{kasa}</p>
            <div style={S.ozetMetrics}>
              <div><p style={S.mLbl}>Brüt</p><p style={S.mVal}>{fmt(t.miktar)}</p></div>
              <div><p style={S.mLbl}>Kom.</p><p style={{ ...S.mVal, color: '#e74c3c' }}>{fmt(t.komisyon)}</p></div>
              <div><p style={S.mLbl}>Net</p><p style={{ ...S.mVal, color: '#2ecc71' }}>{fmt(t.net)}</p></div>
              <div><p style={S.mLbl}>İşlem</p><p style={S.mVal}>{t.sayi}</p></div>
            </div>
          </div>
        ))}
      </div>

      {/* Arama */}
      <div style={S.searchWrap}>
        <FaSearch style={S.searchIcon} />
        <input style={S.searchInput} placeholder="Kasa, yöntem veya alıcı ara..." value={search} onChange={e => setSearch(e.target.value)} />
      </div>

      {/* Tablo */}
      <div style={S.tableWrap}>
        {loading ? <LoadingSpinner /> : (
          <table style={S.table}>
            <thead>
              <tr>{['TARİH', 'KASA', 'YÖNTEM', 'ALICI', 'MİKTAR', 'KOMİSYON', 'TOPLAM', 'NOT', 'İŞLEM'].map(h =>
                <th key={h} style={S.th}>{h}</th>
              )}</tr>
            </thead>
            <tbody>
              {filtered.length === 0
                ? <tr><td colSpan={9} style={S.noData}>Kayıt bulunamadı</td></tr>
                : filtered.map(k => (
                  <tr key={k._id} style={S.tr}>
                    <td style={S.td}>{dayjs(k.tarih?.full).format('DD.MM.YYYY')}</td>
                    <td style={{ ...S.td, fontWeight: 700, color: '#f27127' }}>{k.kasa}</td>
                    <td style={{ ...S.td, color: '#94a3b8' }}>{k.yontem}</td>
                    <td style={S.td}>{k.alici ?? '—'}</td>
                    <td style={{ ...S.td, color: '#e2e8f0' }}>{fmt(k.miktar)}</td>
                    <td style={{ ...S.td, color: '#e74c3c' }}>{fmt(k.komisyon)}</td>
                    <td style={{ ...S.td, fontWeight: 700, color: '#2ecc71' }}>{fmt(k.toplam)}</td>
                    <td style={{ ...S.td, color: '#64748b', maxWidth: 160, overflow: 'hidden', textOverflow: 'ellipsis' }}>{k.not ?? '—'}</td>
                    <td style={S.td}>
                      <button style={S.editBtn} onClick={() => handleDuzenle(k)}><FaEdit /></button>
                      <button style={S.delBtn} onClick={() => handleSil(k._id)}><FaTrash /></button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        )}
      </div>

      {/* Modal */}
      {modal && (
        <div style={S.overlay} onClick={() => setModal(false)}>
          <div style={S.modalBox} onClick={e => e.stopPropagation()}>
            <div style={S.mHeader}>
              <h3 style={S.mTitle}>
                {secili ? <FaEdit style={{ color: '#3498db' }} /> : <FaPlus style={{ color: '#f27127' }} />}
                {secili ? 'Düzenle' : 'Yeni Tahsilat'}
              </h3>
              <button style={S.closeBtn} onClick={() => setModal(false)}>&times;</button>
            </div>
            <div style={S.mBody}>
              <div style={S.formGrid}>
                <FG label="Tarih"><input style={S.inp} type="date" value={form.tarih} onChange={e => setForm(p => ({ ...p, tarih: e.target.value }))} /></FG>
                <FG label="Kasa">
                  <select style={S.inp} value={form.kasa} onChange={e => setForm(p => ({ ...p, kasa: e.target.value }))}>
                    <option value="">Seçin</option>
                    {KASALAR.map(k => <option key={k} value={k}>{k}</option>)}
                  </select>
                </FG>
                <FG label="Yöntem"><input style={S.inp} value={form.yontem} onChange={e => setForm(p => ({ ...p, yontem: e.target.value }))} placeholder="FaynPay, NeopaysBankTransfer..." /></FG>
                <FG label="Alıcı"><input style={S.inp} value={form.alici} onChange={e => setForm(p => ({ ...p, alici: e.target.value }))} /></FG>
                <FG label="Miktar"><input style={S.inp} type="number" value={form.miktar} onChange={e => setForm(p => ({ ...p, miktar: parseFloat(e.target.value) || 0 }))} /></FG>
                <FG label="Komisyon"><input style={S.inp} type="number" value={form.komisyon} onChange={e => setForm(p => ({ ...p, komisyon: parseFloat(e.target.value) || 0 }))} /></FG>
                <FG label="Toplam"><input style={S.inp} type="number" value={form.toplam} onChange={e => setForm(p => ({ ...p, toplam: parseFloat(e.target.value) || 0 }))} /></FG>
                <FG label="Not"><input style={S.inp} value={form.not} onChange={e => setForm(p => ({ ...p, not: e.target.value }))} /></FG>
              </div>
              <div style={S.mFooter}>
                <button style={S.cancelBtn} onClick={() => setModal(false)}>İptal</button>
                <button style={S.submitBtn} onClick={handleKaydet}>Kaydet</button>
              </div>
            </div>
          </div>
        </div>
      )}
      <style>{`@keyframes spin{from{transform:rotate(0)}to{transform:rotate(360deg)}}@keyframes fadeUp{from{opacity:0;transform:translateY(16px)}to{opacity:1;transform:translateY(0)}}`}</style>
    </div>
  );
};

const FG = ({ label, children }) => (
  <div><label style={{ color: '#64748b', fontSize: '0.72rem', fontWeight: 700, display: 'block', marginBottom: 6, textTransform: 'uppercase' }}>{label}</label>{children}</div>
);
const LoadingSpinner = () => (
  <div style={{ display: 'flex', justifyContent: 'center', padding: 60 }}>
    <div style={{ width: 36, height: 36, borderRadius: '50%', border: '3px solid #2d3238', borderTopColor: '#f27127', animation: 'spin 0.8s linear infinite' }} />
  </div>
);

const S = {
  container: { padding: 30, backgroundColor: '#090a0c', minHeight: '100vh', fontFamily: "'Plus Jakarta Sans', sans-serif", animation: 'fadeUp 0.4s ease', color: '#e2e8f0' },
  header: { background: 'linear-gradient(90deg,#16181b,#1c1e22)', border: '1px solid rgba(255,255,255,0.05)', borderRadius: 16, padding: '22px 28px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20, boxShadow: '0 10px 30px rgba(0,0,0,0.2)', flexWrap: 'wrap', gap: 12 },
  hTitle: { color: '#fff', fontSize: '1.4rem', display: 'flex', alignItems: 'center', gap: 8, margin: 0 },
  hSub: { color: '#64748b', fontSize: '0.85rem', margin: '4px 0 0' },
  badge: { background: 'rgba(242,113,39,0.15)', color: '#f27127', padding: '2px 10px', borderRadius: 8, fontSize: '0.85rem' },
  hRow: { display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' },
  select: { background: '#0f1012', border: '1.5px solid #2d3238', borderRadius: 10, color: '#e2e8f0', padding: '9px 12px', fontSize: '0.82rem', cursor: 'pointer' },
  iconBtn: { background: 'rgba(242,113,39,0.1)', border: '1px solid rgba(242,113,39,0.2)', color: '#f27127', borderRadius: 10, width: 38, height: 38, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' },
  addBtn: { background: 'linear-gradient(135deg,#f27127,#ff9a44)', color: '#fff', border: 'none', borderRadius: 10, padding: '9px 16px', fontWeight: 600, display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer' },
  ozetGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill,minmax(220px,1fr))', gap: 14, marginBottom: 20 },
  ozetCard: { background: 'rgba(22,24,27,0.8)', border: '1px solid rgba(255,255,255,0.06)', borderRadius: 14, padding: '16px 20px' },
  ozetKasa: { color: '#f27127', fontSize: '0.82rem', fontWeight: 800, textTransform: 'uppercase', margin: '0 0 10px' },
  ozetMetrics: { display: 'flex', gap: 16, flexWrap: 'wrap' },
  mLbl: { color: '#64748b', fontSize: '0.65rem', fontWeight: 700, textTransform: 'uppercase', margin: '0 0 2px' },
  mVal: { color: '#e2e8f0', fontSize: '0.88rem', fontWeight: 700, margin: 0 },
  searchWrap: { position: 'relative', marginBottom: 20 },
  searchIcon: { position: 'absolute', left: 15, top: '50%', transform: 'translateY(-50%)', color: '#64748b' },
  searchInput: { width: '100%', padding: '13px 13px 13px 42px', background: 'rgba(22,24,27,0.7)', border: '1px solid #2d3238', borderRadius: 12, color: '#fff', fontSize: '0.9rem', boxSizing: 'border-box' },
  tableWrap: { background: 'rgba(22,24,27,0.8)', border: '1px solid rgba(255,255,255,0.05)', borderRadius: 16, overflow: 'auto', boxShadow: '0 8px 30px rgba(0,0,0,0.2)' },
  table: { width: '100%', borderCollapse: 'collapse', minWidth: 860 },
  th: { background: 'rgba(255,255,255,0.02)', padding: '14px 14px', color: '#64748b', fontSize: '0.68rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: 1, borderBottom: '1px solid #2d3238', textAlign: 'left', whiteSpace: 'nowrap' },
  tr: { borderBottom: '1px solid rgba(255,255,255,0.03)' },
  td: { padding: '12px 14px', color: '#94a3b8', fontSize: '0.85rem' },
  noData: { textAlign: 'center', padding: 60, color: '#64748b', fontStyle: 'italic' },
  editBtn: { width: 30, height: 30, borderRadius: 7, border: 'none', background: 'rgba(52,152,219,0.1)', color: '#3498db', marginRight: 5, cursor: 'pointer', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' },
  delBtn: { width: 30, height: 30, borderRadius: 7, border: 'none', background: 'rgba(231,76,60,0.1)', color: '#e74c3c', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' },
  overlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.85)', backdropFilter: 'blur(5px)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 },
  modalBox: { background: '#16181b', border: '1px solid #2d3238', borderRadius: 20, width: '90%', maxWidth: 580, maxHeight: '90vh', overflowY: 'auto', boxShadow: '0 25px 50px rgba(0,0,0,0.5)', animation: 'fadeUp 0.3s ease' },
  mHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '18px 24px', borderBottom: '1px solid #2d3238', position: 'sticky', top: 0, background: '#16181b', zIndex: 1 },
  mTitle: { color: '#fff', fontSize: '1rem', fontWeight: 700, margin: 0, display: 'flex', alignItems: 'center', gap: 8 },
  closeBtn: { background: 'none', border: 'none', color: '#64748b', fontSize: '1.4rem', cursor: 'pointer' },
  mBody: { padding: 24 },
  formGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14, marginBottom: 20 },
  inp: { width: '100%', padding: '10px 13px', background: '#0f1012', border: '1.5px solid #2d3238', borderRadius: 10, color: '#fff', fontSize: '0.87rem', boxSizing: 'border-box' },
  mFooter: { display: 'flex', gap: 12, justifyContent: 'flex-end' },
  cancelBtn: { padding: '10px 20px', borderRadius: 10, background: '#2d3238', color: '#fff', border: 'none', cursor: 'pointer', fontWeight: 600 },
  submitBtn: { padding: '10px 22px', borderRadius: 10, background: 'linear-gradient(135deg,#f27127,#ff9a44)', color: '#fff', border: 'none', cursor: 'pointer', fontWeight: 600 },
};

export default TahsilatYonetimi;
